<section>
  <app-form-header [menuDefinition]="menuDefinition" (onSave)="onSubmit()" (onCancel)="cancel()"></app-form-header>
  @if (form) {
    <form class="astral-content-width astral-stack-l" [formGroup]="form" (ngSubmit)="onSubmit()">
      <section class="astral-section-surface astral-stack-m">
        <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1" alignItems="end">
          <astral-input [control]="form.controls['caption']"></astral-input>
          <astral-select [control]="form.controls['fromBaseIndex']" [itemsSource]="fromBaseIndexSelection"></astral-select>
          <astral-toggle [control]="form.controls['allowLowerThanBaseIndex']"></astral-toggle>
        </astral-layout-group>
      </section>

      <section class="astral-section-surface astral-form-stack">
        <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
          <astral-input type="number" [control]="form.controls['minPercentageChange']"></astral-input>
          <astral-input type="number" [control]="form.controls['maxPercentageChange']"></astral-input>
          <astral-select [control]="form.controls['percentageChangeRounding']" [itemsSource]="percentageChangeRoundingSelection"></astral-select>
          <astral-select [control]="form.controls['indexSeries']" [itemsSource]="indexSeriesSelection"></astral-select>
        </astral-layout-group>

        <astral-layout-group [columns]="1" [mobileColumns]="1">
          <astral-input type="number" [integerOnly]="true" [control]="form.controls['changeIntervalMonths']"></astral-input>
        </astral-layout-group>
      </section>
    </form>
  }
</section>
